import React from "react";
/* eslint-disable */
import Header from "../../header";
import Banner from "../Banner";
import SubNav from "../SubNav";
import Footer from "../../Footer";
import CustomTable from "../../CustomTable.js";
import pricing from '../../../assets/Data/pricingData';

const userfriendly = require("../../../assets/icons-pack/4.2 Volume Backup Service/ic_01_userfriendly.svg");
const agile = require("../../../assets/icons-pack/4.2 Volume Backup Service/ic_02_agile.svg");
const lowcost = require("../../../assets/icons-pack/4.2 Volume Backup Service/ic_03_lowcost.svg");
const safetyandsecure = require("../../../assets/icons-pack/4.2 Volume Backup Service/ic_04_safetyandsecure.svg");

const PBS = () => {
    const heading = `PREMIUM BACKUP SERVICE (PBS)`;
    const details = `Powered by Commvault`;

    const overview = [
        `Premium Backup Service (PBS) provides online backup for Elastic Volume Service (EVS) disks and allows data restoration from backups, offering protection against virus attacks and software and hardware faults. The Premium Backup Service ensures that EVS disks can be backed up online without interrupting services, and backup files can be used to seamlessly restore EVS disks.`
    ];

    const advantages = [
        [
            `User Friendly `,
            `DETASAD’s PBS is an easy to use backup solution as it can be configured easily. In addition, the storage space on backup servers can be easily expanded when required. `,
            userfriendly
        ],
        [
            `Agile`,
            `You can apply different backup policies as per your requirements. PBS provides a flexible and agile backup policy configuration. `,
            agile
        ],
        [
            `Low Cost `,
            `PBS allows you to take a full initial backup which is then followed by regular incremental backups. It significantly reducing the space occupied by backup files.  `,
            lowcost
        ],
        [
            `Safe & Secure `,
            `With DETSAD PBS, rest assured that your data backup is also protected. Backup data is stored in multiple data centers, ensuring 99.999% data durability. `,
            safetyandsecure
        ]
    ];

    const functions = [
        [
            `Efficient`,
            [
                `Permanent incremental backup and restoration significantly reduces the space occupied by backup files and reduces the RTO to minutes.`
            ]
        ],
        [
            `Automatic Backups`,
            [
                `Policies can be easily defined for backing up data online. A backup policy can be easily defined and associated with one or more EVS disks to implement automatic backup.`
            ]
        ],
        [
            `Simple Process`,
            [
                `Backup can start preparing after three steps and in case of restoration, the backup can be restored in two steps.`
            ]
        ]
    ];
    let TablesData = []
    pricing.map(price => {
        price.price = parseFloat(price.price).toFixed(2);
        if(price.name.includes('Premium-Backup-Service') ){
            console.log(price,'price')
            price['monthlyPricing'] = price.price
            TablesData.push(price) 
        }
    })
    return (
        <div>
            <Header />
            <Banner heading={heading} details={details} className="bg-storage"/>
            <SubNav overview={overview} advantages={advantages} functions={functions} CustomTable={CustomTable} TablesData = {TablesData} onlyMonthly/>
            <Footer />
        </div>
    );
};

export default PBS;
